const preloadResources = (resource: string) => {
    return fetch(resource, { method: 'GET' })
        .then((response) => {
            if (!response.ok) {
                console.error(`Failed to fetch resource: ${resource}`);
            }
            return response.blob();
        })
        .catch((error) => {
            console.error(`Error fetching resource: ${resource}`, error);
        });
}

export const preloadResourcesList = (preloadEnabled: boolean) => {
    const resources = ['https://a.tangent.ai/quiz-inline/mediapipe-models/wasm/vision_wasm_internal.js', 'https://a.tangent.ai/quiz-inline/mediapipe-models/wasm/vision_wasm_internal.wasm', 'https://a.tangent.ai/quiz-inline/mediapipe-models/wasm/vision_wasm_nosimd_internal.js', 'https://a.tangent.ai/quiz-inline/mediapipe-models/wasm/vision_wasm_nosimd_internal.wasm', 'https://a.tangent.ai/quiz-inline/mediapipe-models/face_landmarker/float16/1/face_landmarker.task'];

    if (!preloadEnabled) return;
    resources.forEach((resource) => {
        preloadResources(resource)
    });
}